import { useMemo, useState } from "react";
import useAuthentication from "@hooks/useAuthentication";
import SortComponent from "./component/SortComponent";
import { useMutation } from "react-query";
import { menuRearrange } from "./services";
import usePopup from "@hooks/usePopup";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { PermissionsType } from "Types/Authentication/AuthenticationTypes";
import { blueGrey } from "@mui/material/colors";
const MenuRearrange = () => {
  const { permissions, user, setRefetchPermission } = useAuthentication();
  const { showSnackbar } = usePopup();
  const [selected, setSelected] = useState<{ [key: number]: number }>({});
  const { mutate: rearrange, isLoading } = useMutation(menuRearrange, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 4000,
        });
        setRefetchPermission(true);
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 4000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message: e?.response?.data?.responseMessage || "Something went wrong !",
        open: true,
        variant: "error",
        duration: 4000,
      });
    },
  });

  const handleChange = (params: { newOrder: number; oldOrder: number }) => {
    rearrange({
      clinicId: Number(user?.clinicId),
      currentOrder: params.oldOrder,
      newOrder: params.newOrder,
    });
  };

  const handleClick = (data: any) => {
    if (!selected[data.id] && Boolean(data?.children?.length)) {
      const update = { ...selected, [data.id]: data.id };
      console.log(update);
      setSelected(update);
    }
  };

  const handleClear = (id: number) => {
    const updated = { ...selected };
    if (updated[id]) {
      delete updated[id];
    }
    setSelected(updated);
  };

  const formatData = (data: PermissionsType[]) => {
    let formated: any[] = [];
    for (let i = 0; i < data.length; i++) {
      if (selected[data[i].id]) {
        formated = [data[i], ...formated];
      }
      if (data[i]?.children?.length > 0) {
        formated = [...formatData(data[i].children), ...formated];
      }
    }
    return formated;
  };

  const selectedList = useMemo(() => {
    try {
      let data = formatData(permissions[0].children);
      return data;
    } catch (e) {
      console.log(e);
      return [];
    }
  }, [selected, permissions]);

  return (
    <div className="">
      <div className="grid grid-cols-2 gap-4 pt-3">
        <Paper className="p-2 h-fit" sx={{ backgroundColor: blueGrey[200] }}>
          <Typography variant="h6" sx={{ p: 1 }}>
            Main menu
          </Typography>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: 2,
              p: 2,
              height: "fit-content",
            }}
          >
            <SortComponent
              items={permissions[0]?.children || []}
              onChange={handleChange}
              onSelect={handleClick}
              loading={isLoading}
            />
          </Box>
        </Paper>
        <div className="flex flex-col gap-2 max-h-[82dvh] overflow-y-auto pb-2">
          {selected &&
            selectedList?.map((menu: PermissionsType) => (
              <Paper className="p-2" sx={{ backgroundColor: blueGrey[200] }}>
                <div className="flex justify-between items-center p-1">
                  <Typography variant="h6">{menu?.name || "List"}</Typography>
                  <IconButton
                    color="error"
                    onClick={() => {
                      handleClear(menu.id);
                    }}
                  >
                    <CancelIcon />
                  </IconButton>
                </div>
                <Box sx={{ backgroundColor: "white", borderRadius: 2, p: 2 }}>
                  <SortComponent
                    items={menu?.children || []}
                    onChange={handleChange}
                    onSelect={handleClick}
                    loading={isLoading}
                  />
                </Box>
              </Paper>
            ))}
        </div>
      </div>
    </div>
  );
};

export default MenuRearrange;
